const PATH = "/api/v1/rzp-payment";

const ENDPOINTS = {
  RZP_PROCESS_ORDER: "/process-order/",
  RZP_PAYMENT_RESPONSE: "/payment-response/",
};

export type RZPPaymentEndpoints = keyof typeof ENDPOINTS;
export const RZPPaymentCollection = { PATH, ENDPOINTS };
